import { CSSProperties } from 'react'

export const CELL_SPAN_STYLE:CSSProperties = {
	display: 'inline-block',
	width: '100%',
}

